import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  getFormMetaController,
  getFormData,
} from '../../selectors/formSelector';
import EditButton from './editButton';
import ConfirmationCheckbox from './controls/confirmationCheckbox';
import ltAnalytics from '../../utils/ltAnalyticsService';
import * as eventnames from '../../common/trackingeventnames';

const SummarySteps = ({ step, attributeId, action }) => {
  const formMeta = useSelector(getFormMetaController);
  const formData = useSelector(getFormData);

  useEffect(() => {
    if (formMeta) {
      ltAnalytics(eventnames.SUMMARY_STEP_VIEWED, {
        ...formMeta,
      });
    }
  }, []);

  /**
   * Render hidden inputs for Jornaya tracking on summary step.
   * Jornaya can only track data in <input> elements, not text in <div>s.
   * If the first step has Jornaya enabled, render inputs for all steps.
   */
  const renderJornayaTrackingInputs = () => {
    return step.stepsData.map((stepData) => {
      const value = formData[stepData.attributeid] || '';
      if (!value) return null;

      return (
        <input
          key={`jornaya-${stepData.attributeid}`}
          type="text"
          id={`formData.${stepData.attributeid}`}
          name={stepData.attributeid}
          value={value}
          readOnly
          tabIndex="-1"
          aria-hidden="true"
          data-jornaya-tracked="true"
        />
      );
    });
  };

  // Only render Jornaya inputs if first step has Jornaya enabled
  const hasJornayaSteps =
    step.stepsData &&
    formData &&
    step.stepsData.length > 0 &&
    step.stepsData[0].requiresJornaya === true;

  return (
    <div className={`ltSummaryParent ${attributeId}`}>
      {step.individualSummaries}

      {hasJornayaSteps && (
        <div
          style={{
            position: 'absolute',
            left: '-9999px',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
          }}
          aria-hidden="true"
        >
          {renderJornayaTrackingInputs()}
        </div>
      )}

      {step.showConfirmationlabel === true && (
        <div className="checkBoxContainer">
          {<ConfirmationCheckbox step={step} />}
        </div>
      )}
      {step.showEditButton && (
        <div className="ltSummaryEditContainer">
          <EditButton action={action} label={step.editButtonLabel} />
        </div>
      )}
    </div>
  );
};

SummarySteps.propTypes = {
  attributeId: PropTypes.string,
  step: PropTypes.shape({
    stepsData: PropTypes.arrayOf(PropTypes.object),
    individualSummaries: PropTypes.node,
    showConfirmationlabel: PropTypes.bool,
    showEditButton: PropTypes.bool,
    editButtonLabel: PropTypes.string,
  }),
  action: PropTypes.func,
};

export default SummarySteps;
